<template>
  <div class="home">
    <div class="scroll-container">
      <div
        v-for="product in products"
        :key="product.id"
        class="slide-item"
        @click="goToDetail(product.id)"
      >
        <div class="image-wrapper">
          <img
            v-if="product.coverImage"
            :src="product.coverImage"
            :alt="product.name"
          >
          <div v-else class="placeholder">
            <span>暂无图片</span>
          </div>
        </div>
        <div class="overlay-bottom">
          <!-- 优雅的状态标记 -->
          <span class="status-dot" :class="product.status">
            <span class="dot"></span>
            {{ product.status === 'onSale' ? '在售' : '已下架' }}
          </span>
          <div class="product-meta">
            <span class="number">{{ product.dollNumber }}</span>
            <h2 class="name">{{ product.name }}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { productApi } from '../api';

export default {
  name: 'Home',
  data() {
    return {
      products: []
    };
  },
  mounted() {
    this.loadProducts();
  },
  methods: {
    async loadProducts() {
      try {
        const res = await productApi.getList();
        if (res.data.code === 200) {
          this.products = res.data.data;
        }
      } catch (e) {
        console.error(e);
      }
    },
    goToDetail(id) {
      this.$router.push({ name: 'Detail', params: { id } });
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+SC:wght@400;600;700&display=swap');

.home {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #f5f3f0;
}

.scroll-container {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
}

.slide-item {
  width: 100%;
  height: 100vh;
  scroll-snap-align: start;
  position: relative;
}

.image-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.placeholder {
  width: 100%;
  height: 100%;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 18px;
}

/* 底部信息区域 - 更精致 */
.overlay-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 48px 28px 36px;
  background: linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.4) 40%, transparent 100%);
  color: #fff;
}

/* 优雅状态指示 - 小圆点 + 文字 */
.status-dot {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  letter-spacing: 1px;
  opacity: 0.9;
  margin-bottom: 14px;
  font-family: 'Noto Serif SC', 'Georgia', serif;
}

.status-dot .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}

.status-dot.onSale .dot {
  background: #9ed9c0;
  box-shadow: 0 0 6px rgba(158, 217, 192, 0.5);
}

.status-dot.offSale .dot {
  background: #e8c4a0;
  box-shadow: 0 0 6px rgba(232, 196, 160, 0.5);
}

.product-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.number {
  font-size: 13px;
  opacity: 0.7;
  letter-spacing: 2px;
  font-family: 'Courier New', monospace;
}

.name {
  font-size: 26px;
  font-weight: 600;
  font-family: 'Noto Serif SC', 'Georgia', serif;
  line-height: 1.35;
  text-shadow: 0 1px 4px rgba(0,0,0,0.2);
}
</style>
